<template>
  <div class="w-screen h-screen overflow-hidden bg-black-10">
    <title-bar class="h-10" />
    <div class="h-[calc(100vh-40px)]">
      <ConfigProvider :locale="zhCN" :auto-insert-space-in-button="false">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
        <modal-watchface-manage ref="createModalRef" />
      </ConfigProvider>
    </div>

    <!-- 全局通用modal -->
    <modal-loading />
  </div>
</template>

<script setup lang="ts">
import {
  useEmitterListener,
  useEventListener,
  useIsIntranet,
  useRemoteLibs,
  useTextFont,
  useWebVersion
} from './hooks';
import { EventType, emitter } from './utils/emitter.utils';
import {
  WatchfaceStorage,
  useWatchfaceHistory
} from './hooks/use-watchface-history';
import { useGlobalShortcuts } from './hooks';
import { ElectronApi } from './services/electron.api';
import { onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { ConfigProvider } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { initOnetrack } from './utils/track';
import { emptyDir } from './utils/fs/fs-extra.utils';

const { autoCheckVersion } = useWebVersion();

// 打开记录
const { updateItems } = useWatchfaceHistory();
onBeforeMount(() => WatchfaceStorage.init());
useEmitterListener(
  [
    EventType['watchface:description-update'],
    EventType['watchface:description-saved']
  ],
  updateItems
);
// 验证表盘列表
watch(() => WatchfaceStorage.data, updateItems, {
  immediate: true,
  deep: true
});

// 全局快捷键
useGlobalShortcuts(
  [
    {
      keyboardKeys: ['F12'],
      handler: () => ElectronApi.openDevtools()
    },
    {
      keyboardKeys: ['CommandOrControl', 'Q'],
      handler: () => ElectronApi.close()
    },
    {
      keyboardKeys: ['CommandOrControl', 'M'],
      handler: () => ElectronApi.minimize()
    }
  ],
  undefined
);

// update
onMounted(async () => {
  initOnetrack();
});

// Window focus和blur
useEventListener('focus', () => {
  emitter.emit(EventType['window:foucs']);
});
useEventListener('blur', () => {
  emitter.emit(EventType['window:blur']);
});

// 字体加载
const { loadAllFonts } = useTextFont();
onBeforeMount(() => loadAllFonts());

// 远程libs
const { autoDownloadAll } = useRemoteLibs();
onMounted(() => autoDownloadAll());

// 判断关闭时是否保存
const canClose = () => {
  // try {
  //   ElectronApi.close();
  // } catch (error) {
  //   ElectronApi.exit();
  // }
};
onMounted(() => {
  ElectronApi.ipcRenderer?.on('before-close', canClose);
});
onBeforeUnmount(() => {
  ElectronApi.ipcRenderer?.off('before-close', canClose);
});

// 判断是否内网
const { testIsIntranet } = useIsIntranet();
onMounted(testIsIntranet);
useEventListener('focus', testIsIntranet);

// modal
const createModalRef = ref();
const openModal = (data: { mode: string; path?: string }) => {
  const { mode, path } = data;
  if (!path && !mode) return;
  createModalRef.value?.open?.({
    mode: path ? mode : 'create',
    path
  });
};
useEmitterListener(EventType['modal:watchface-manage'], openModal);

useEmitterListener([EventType['window:foucs']], () => {
  console.log('check and tell user to update tools if there has new version');
  autoCheckVersion();
});

onBeforeUnmount(async () => {
  try {
    const tempPath = await ElectronApi.getPath('temp');
    emptyDir(tempPath);
  } catch (error) {
    console.log(error);
  }
});
</script>

<style scoped lang="less"></style>
